import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import ContactElement from '../ContactElement';
var Call = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Call, _React$PureComponent);
  var _super = _createSuper(Call);
  function Call() {
    _classCallCheck(this, Call);
    return _super.apply(this, arguments);
  }
  _createClass(Call, [{
    key: "getCallLink",
    value: function getCallLink() {
      var phoneNumber = this.props.phoneNumber;
      var countryCode = '1';
      var cleanPhoneNumber = phoneNumber.replace(/[^\d]/g, '');
      return "tel:+".concat(countryCode).concat(cleanPhoneNumber);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        phoneNumber = _this$props.phoneNumber,
        as = _this$props.as,
        header = _this$props.header,
        iconPosition = _this$props.iconPosition,
        showIcon = _this$props.showIcon,
        buttonColor = _this$props.buttonColor,
        className = _this$props.className,
        fluidButton = _this$props.fluidButton,
        buttonSize = _this$props.buttonSize,
        label = _this$props.label;
      return /*#__PURE__*/React.createElement(ContactElement, {
        contact: label || phoneNumber,
        link: this.getCallLink(),
        iconType: showIcon || as === 'icon' ? 'phone' : 'none',
        as: as,
        header: header,
        className: className,
        buttonColor: buttonColor,
        iconPosition: iconPosition,
        fluidButton: fluidButton,
        buttonSize: buttonSize
      });
    }
  }]);
  return Call;
}(React.PureComponent);
export { Call as default };
Call.defaultProps = {
  as: 'text',
  buttonColor: 'default',
  buttonSize: 'large',
  label: '',
  className: '',
  fluidButton: false,
  header: '',
  iconPosition: 'left',
  showIcon: false
};
Call.propOptions = {
  header: ['Call Us', ''],
  buttonColor: ['primary', 'secondary', 'default'],
  iconPosition: ['left', 'top']
};